import {
	GET_INDUSTRY_FULL_TREE_WATCHER,
	GET_INDUSTRY_FULL_TREE_SUCCESS,
	GET_INDUSTRY_FULL_TREE_FAILED
} from './constants';

const initialState = {
	isLoading: true,
	data: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case GET_INDUSTRY_FULL_TREE_WATCHER:
			return {
				isLoading: true,
				data: []
			};
		case GET_INDUSTRY_FULL_TREE_SUCCESS:
			return {
				isLoading: false,
				data: action.payload
			};
		case GET_INDUSTRY_FULL_TREE_FAILED:
			return {
				isLoading: false,
				data: action.payload
			};
		default:
			return state;
	}
};
